import { createAction } from '@reduxjs/toolkit';

export const historyPush = createAction<string, 'HISTORY_PUSH'>('HISTORY_PUSH');

export const historyReplace = createAction<string, 'HISTORY_REPLACE'>(
  'HISTORY_REPLACE',
);

export const historyGoBack = createAction<void, 'HISTORY_GO_BACK'>(
  'HISTORY_GO_BACK',
);

export const windowLocationChange = createAction<
  string,
  'WINDOW_LOCATION_CHANGE'
>('WINDOW_LOCATION_CHANGE');
